export default "__VITE_ASSET__C35_Ifut__ 400w, __VITE_ASSET__ChGobFGE__ 800w, __VITE_ASSET__BZvQtHB4__ 1024w";